var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 105.8 93.100001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "translate(-51.4 -51.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m51.4 123.3 8.9 15.4c1.8 3.5 5.4 5.9 9.5 5.9h59.3l-12.3-21.3z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M157.2 123.4c0-2.1-.6-4.1-1.7-5.8l-34.8-60.4c-1.8-3.4-5.3-5.7-9.4-5.7H92.9l53.7 93 8.5-14.7c1.6-2.8 2.1-4 2.1-6.4z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2",
    d: "m84.2 66.6-24 41.5h47.9z",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtstation);
export default __webpack_public_path__ + "static/media/artstation.2e453e6d43a57c2c5f261e9e331672db.svg";
export { ForwardRef as ReactComponent };